import moment from 'moment';

const filteringFromObject = (object, typeMapping = {}) => {
    if (!object) {
        return null;
    }

    const filtering = [];

    for (const key in object) {

        // 0 or false are valid values for filtering.
        if (object[key] === null || object[key] === undefined || object[key] === 0) {
            continue;
        }

        const type = typeMapping[key] || typeof object[key];
        switch (type) {
            case 'date':
                filtering.push({
                    field: key,
                    eq: moment(object[key]).format('YYYY-MM-DD')
                });

                break;
            case 'number':
            case 'boolean':
                filtering.push({
                    field: key,
                    eq: object[key]
                });

                break;
            default:
                filtering.push({
                    field: key,
                    like: '%' + object[key] + '%'
                });
        }
    }

    return JSON.stringify(filtering);
}

export default filteringFromObject;
